import { Transaction } from 'types';

import { createTransaction } from 'modules/transactions/utils/createTransaction';

import transactionTypes from 'constants/transactionTypes';
import { CustomRange } from '../types/CustomRange';

export const getTransactions = (editedRanges: CustomRange[]) => {
  const reclassificationTRansactions = editedRanges.map(
    (range: CustomRange) =>
      createTransaction({
        range,
        transactionType: transactionTypes.RECLASSIFICATION,
        newFrom: range.newFrom,
        newTo: range.newTo,
        newShareClass: range.selectedShareClassOption?.value || '',
      }) as Transaction
  );

  return reclassificationTRansactions;
};
